import { SIGNEDHUMAN_API } from '@app/utils/apiUrl';
import { messageToast, status200 } from '@app/utils/define';
import { Post } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';

const handleExport = async (values) => {
    const model = { ...values };

    try {
        const res = await Post(SIGNEDHUMAN_API.EXPORT_PDF, null, model, false, false, true);
        if (res && res.data && res.data.length === 0) {
            toast.error("Đã có lỗi xảy ra khi xuất biểu mẫu Phụ lục 2 (Word), vui lòng thử lại!");
        } else {
            toast.success("Xuất biểu mẫu Phụ lục 2 (Word) thành công!");
        }

        var data = res.data;
        var filePath = data[0].savePath;

        return filePath;
    } catch (error) {
        toast.error(error?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
    }
};

/**
 * Xuất biểu mẫu Phụ lục 2 (Cấp chứng nhận CME) dưới định dạng file Word (.doc)
 * Sử dụng định dạng HTML-to-Word kèm thiết lập trang nằm ngang (Landscape) và Font chữ chuẩn.
 * 
 * @param {Array} recordList Danh sách học viên điểm danh
 * @param {Object} eventData Thông tin lớp học/khóa đào tạo
 * @param {string} filePath Đường dẫn file Word mẫu
 */
export const exportToWordPhuLuc2 = async (recordList, eventData, filePath, userMap = {}, unitMap = {}) => {
    if (!recordList || recordList.length === 0) {
        toast.warning("Không có dữ liệu để xuất.");
        return;
    }

    if (!eventData) {
        toast.error("Thiếu thông tin khóa đào tạo.");
        return;
    }

    // Tạo cấu trúc bảng HTML hàng loạt
    let tableRows = "";

    var lstExport = [];
    recordList.forEach((item, idx) => {
        // Lấy trực tiếp thông tin từ userMap/unitMap được truyền sang
        const userObj = userMap[item.userId];
        const unitObj = unitMap[item.userId];

        const fullName = userObj?.fullName || " ";
        const cccd = userObj?.username || " ";
        const unit = item.maDonVi || unitObj?.code || " ";

        var exportItem = {
            id: item.id,
            stt: idx + 1,
            canCuocCongDan: cccd,
            hoTen: fullName,
            donVi: unit
        };
        lstExport.push(exportItem);
    });

    var exportItem = {
        id: eventData.id,
        chuDe: eventData.tenKhoaDaoTao,
        chuTri: eventData.chuTri,
        baoCaoVien: eventData.baoCaoVien,
        hinhThuc: "Tham gia hoạt động sinh hoạt chuyên môn - Phân tích ca bệnh",
        tuNgay: moment(eventData.tuNgay),
        denNgay: moment(eventData.denNgay),
        diaDiem: eventData.diaDiem || '',
        soTinChi: eventData.soGioTinChi,
        lstExport: lstExport,
    }

    var model = {
        exportItem: exportItem,
        filePath: filePath,
        fileName: `${moment().format('DDMMYYYY_HHmmss')}_giay_de_nghi_cme`
    }

    var result = await handleExport(model);

    return result;

};

export const exportToBienBan = async (recordList, eventData, filePath, userMap = {}, unitMap = {}) => {
    if (!eventData) {
        toast.error("Thiếu thông tin khóa đào tạo.");
        return;
    }

    let thaoLuan = eventData.noiDungThaoLuan || '';
    try {
        const parsed = typeof thaoLuan === 'string' ? JSON.parse(thaoLuan) : thaoLuan;
        if (Array.isArray(parsed)) {
            thaoLuan = parsed
                .filter(item => item.nguoiDongGop || item.noiDung)
                .map((item, index) => `${index + 1}. ${item.nguoiDongGop || ''}:\r\n${item.noiDung || ''}`)
                .join('\r\n');
        }
    } catch {
        // Giữ nguyên nội dung nếu không phải JSON.
    }

    var exportItem = {
        id: eventData.id,
        diaDiem: eventData.diaDiem || '',
        chuTri: eventData.chuTri,
        thuKy: eventData.thuKy || '',
        thanhPhanThamGia: eventData.thanhPhanThamGia || '',
        thoiGianBatDau: eventData.thoiGianBatDau || eventData.tuNgay || '0001-01-01T00:00:00',
        thoiGianKetThuc: eventData.thoiGianKetThuc || eventData.denNgay || '0001-01-01T00:00:00',
        tenBaoCao: eventData.tenBaoCao || '',
        baoCaoVien: eventData.baoCaoVien || '',
        thaoLuan,
        ketLuanThongNhat: eventData.ketLuanThongNhat || '',
        ketLuanTrienKhai: eventData.ketLuanTrienKhai || ''
    }

    var model = {
        exportItem: exportItem,
        filePath: filePath,
        exportType: 'bienBan',
        fileName: `${moment().format('DDMMYYYY_HHmmss')}_bien_ban_dieu_duong`
    }

    var result = await handleExport(model);

    return result;

};
